import React, { useEffect } from 'react';
import Session from "../../Session";
import WorkflowsForms from "../WorkflowsForms/index.jsx";


const Interaction = ({ data }) => {
  useEffect(() => {
    Session.uid(data.uid);
    if (data) {
      sessionStorage.setItem("externalCode", data.externalCode);
    }
  }, [data]);

  return (
    <>
      <WorkflowsForms
        externalCode={data.externalCode}
        data={data}
      />
    </>
  );
};

export default Interaction;
